export const sentenceCase = (v?: string): string | undefined => (v ? `${v.slice(0, 1).toUpperCase()}${v.slice(1)}` : v)
